const selectRowColumnId = '__asc-data-grid-column--select-row__';
const expandRowColumnId = '__asc-data-grid-column--expand-row__';
function selectRowColumn() {
  return {
    dataKey: selectRowColumnId
  };
}
selectRowColumn.isSelectRowColumn = function isSelectRowColumn(column) {
  return column.dataKey === selectRowColumnId;
};
function expandRowColumn(_ref) {
  let {
    content,
    hasContent,
    ...options
  } = _ref;
  return {
    ...options,
    dataKey: expandRowColumnId,
    hasContent,
    content
  };
}
expandRowColumn.isExpandRowColumn = function isExpandRowColumn(column) {
  return column.dataKey === expandRowColumnId;
};
expandRowColumn.hasContent = function hasContent(column, data) {
  return !column.hasContent || column.hasContent(data);
};
export { selectRowColumn, expandRowColumn };